module.exports = "/images/SetUpYourCompany-2.jpg";